import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AngularFirestore } from '@angular/fire/firestore';  // Firebase modules for Database, Data list and Single object
import { Observable } from 'rxjs/Observable';

import { User } from "./profile.model";
import { AuthService } from "app/core/auth.service";


// export interface User { 
//   name: string; 
//   second_name: string; 
//   phone: string; 
//   country: string,
// }

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  // uid: string;

  constructor(
    private _httpClient: HttpClient,
    private afs: AngularFirestore,
    private authService: AuthService
  ) { 
    
  }

  // Get user UID
  get uid() {
    return this.authService.user.uid;
  }

  getProfile(): Observable<User> {
    return new Observable((observer) => {
      this.afs.collection('users').doc(this.uid).ref.get().then(data => {
        let user: User = new User({});
        user.id = this.uid;
        user.name = data.data().name;
        user.second_name = data.data().second_name;
        user.phone = data.data().phone;
        user.country = data.data().country;
        user.photoUrl = data.data().photoUrl;

        observer.next(user);
      })
    })
  }

  /**
     * Update category
     *
     * @param CategoryExpense
     * @returns {Observable<any>}
     */
    updateProfile(user: User): Observable<any> {
      return new Observable((observer) => {
        var userRef = this.afs.collection("users").doc(this.uid);
        userRef.update({
          name: user.name,
          second_name: user.second_name,
          phone: user.phone,
          country: user.country,
          photoUrl: user.photoUrl,
          uid: this.uid
        })
          .then(function () {
            observer.next();
          });
      });
    }
}
